/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_MarketingInputs */

const en_role_marketing = /** @type {(inputs: Role_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

const es_role_marketing = /** @type {(inputs: Role_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing`)
};

/**
* | output |
* | --- |
* | "Marketing" |
*
* @param {Role_MarketingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_marketing = /** @type {((inputs?: Role_MarketingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_MarketingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_marketing(inputs)
	return es_role_marketing(inputs)
});